import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=34b87885&"
import script from "./blank.vue?vue&type=script&lang=ts&"
export * from "./blank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlankHeader: require('/home/ec2-user/environment/xsearch-app.accessbility/src/components/BlankHeader.vue').default,Footer: require('/home/ec2-user/environment/xsearch-app.accessbility/src/components/Footer.vue').default,MyFolderMsgModal: require('/home/ec2-user/environment/xsearch-app.accessbility/src/components/MyFolderMsgModal.vue').default})
